<template>
  <section class="raised-cta">
    <div class="grid grid--container">
      <Paper class="raised-cta__card" :elevation="1" :color="color">
        <div class="raised-cta__card__content">
          <VText class="raised-cta__card__title" variant="h2">{{
            title
          }}</VText>
          <VText class="raised-cta__card__text" v-if="text">{{ text }}</VText>
        </div>
        <div class="raised-cta__card__cta">
          <slot />
        </div>
      </Paper>
    </div>
  </section>
</template>

<script>
import { Paper, VText } from '@campsite-bio/component-lib';

export default {
  components: {
    Paper,
    VText,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    color: {
      type: String,
      default: 'gray100',
    },

    text: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.raised-cta {
  padding: 5rem 0;

  &__card {
    &__cta {
      white-space: nowrap;

      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
  }
}

.raised-cta__card.raised-cta__card {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 2rem;

  @media (min-width: 768px) {
    flex-wrap: unset;
  }
}

.raised-cta__card__title + .raised-cta__card__text {
  margin-top: 0.75rem;
}

.raised-cta__card__text.raised-cta__card__text {
  font-size: 1.15rem;
}
</style>
